export default `Geography,Population
New South Wales,8118000
Victoria,6629900
Queensland,5115500
South Australia,1756500
Western Australia,2630600
Tasmania,535500
Northern Territory,245600
Australian Capital Territory,428100`